<template>
   
    <div class="row match-height">
        <div class="col-12">
            <div class="card card-statistics">
                    <div class="card-body statistics-body" v-if="userStore.userDashboard.creditScores">
                        <div class="row mx-auto" v-if="userStore.userDashboard.creditScores.length > 0">
                            <div class="col-xl-3 col-sm-6 col-12 mb-2 mb-xl-0">
                                <div class="d-flex flex-row">
                                    <div class="avatar bg-light-info me-2">
                                        <div class="avatar-content">
                                            <i data-feather='box' class="avatar-icon"></i>
                                        </div>
                                    </div>
                                    <div class="my-auto mx-1">
                                        <h4 class="fw-bolder mb-0">{{ userStore.userDashboard.inquiryTable.count }}</h4>
                                        <p class="card-text font-small-4 mb-0"> INQUIRIES</p>
                                    </div>
                                </div>
                                <div class="my-auto mx-auto p-1">
                                    <small class="card-text font-small-6">
                                        Each time you apply for credit it lowers your score. For that reason we ask during credit repair that you do not apply for anything.
                                    </small>
                                </div>
                            </div>
                            <div class="col-xl-3 col-sm-6 col-12 mb-2 mb-xl-0">
                                <div class="d-flex flex-row">
                                    <div class="avatar bg-light-warning me-2">
                                        <div class="avatar-content">
                                            <i data-feather='box' class="avatar-icon"></i>
                                        </div>
                                    </div>
                                    <div class="my-auto mx-1">
                                    <h4 class="fw-bolder mb-0">{{ userStore.userDashboard.latepaymentTable.count }}</h4>
                                    <p class="card-text font-small-4 mb-0">LATE PAYMENTS</p>
                                    </div>
                                </div>
                                <div class="my-auto mx-auto p-1">
                                    <small class="card-text font-small-6">
                                        A late payment that’s more than 30 days past due can knock as many as 100 points
                                        off your credit score. If your score is already low, it won’t hurt it as much
                                        but will still do damage.
                                    </small>
                                </div>
                            </div>
                            <div class="col-xl-3 col-sm-6 col-12 mb-2 mb-sm-0">
                                <div class="d-flex flex-row">
                                    <div class="avatar bg-light-danger me-2">
                                        <div class="avatar-content">
                                            <i data-feather='box' class="avatar-icon"></i>
                                        </div>
                                    </div>
                                    <div class="my-auto mx-1">
                                    <h4 class="fw-bolder mb-0">{{ userStore.userDashboard.collectionTable.count }}</h4>
                                    <p class="card-text font-small-4 mb-0">DEROGATORIES</p>
                                    </div>
                                </div>
                                <div class="my-auto mx-auto p-1">
                                <small class="card-text font-small-6">
                                    Recent charge-offs, collections, and other derogatory items within the last six months will hurt your credit score more
                                    than older inactive accounts. Accounts within the last 24 months carry the second most weight.
                                </small>
                            </div>
                            </div>
                            <div class="col-xl-3 col-sm-6 col-12 mb-2 mb-sm-0">
                                <div class="d-flex flex-row">
                                    <div class="avatar bg-light-danger me-2">
                                        <div class="avatar-content">
                                            <i data-feather='box' class="avatar-icon"></i>
                                        </div>
                                    </div>
                                    <div class="my-auto mx-1">
                                    <h4 class="fw-bolder mb-0">{{ userStore.userDashboard.publicRecordBankruptcyTable.count }}</h4>
                                    <p class="card-text font-small-4 mb-0">PUBLIC RECORDS</p>
                                    </div>
                                </div>
                                <div class="my-auto mx-auto p-1">
                                    <small class="card-text font-small-6">
                                        Public records include details of court records, bankruptcy filings, tax liens and monetary judgments.
                                        These generally remain on your Credit Report for 7 to 10 years
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>
    <div v-if="userStore.userDashboard.creditScores">
        <div class="col-lg-12 col-12" v-if="userStore.userDashboard.creditScores.length > 0">
            <div class="card card-company-table">
                <div class="card-body p-0">
                    <div class="table-responsive">
                        <table class="table">
                                <thead class="thead-primary">
                                    <tr>
                                        <th>Account Type:</th>
                                        <th style="text-align: left;"><img src="https://prolific-develop.com/landing/images/transunion.png" width="75" height="75" alt="image" style="display: block; ">
                                           <h6 v-if="userStore.userDashboard.creditScores[0]">Current Score: {{userStore.userDashboard.creditScores[0].credit_score}}</h6>
                                           <h6 v-else>Current Score: NOT REPORTED</h6>
                                        </th>
                                        <th style="text-align: left;"><img src="https://prolific-develop.com/landing/images/equifax.png" width="75" height="75" alt="image" style="display: block; ">
                                            <!-- <h6>Current Score: {{ isset($creditScores[1]) ? $creditScores[1]['credit_score'] : "NOT REPORTED" }}</h6> -->
                                            <h6 v-if="userStore.userDashboard.creditScores[1]">Current Score: {{userStore.userDashboard.creditScores[1].credit_score}}</h6>
                                            <h6 v-else>Current Score: NOT REPORTED</h6>
                                        </th>
                                        <th style="text-align: left;"><img src="https://prolific-develop.com/landing/images/experian.png" width="75" height="75" alt="image" style="display: block; ">
                                            <!-- <h6>Current Score: {{ isset($creditScores[2]) ? $creditScores[2]['credit_score'] : "NOT REPORTED" }}</h6> -->
                                            <h6 v-if="userStore.userDashboard.creditScores[2]">Current Score: {{userStore.userDashboard.creditScores[2].credit_score}}</h6>
                                            <h6 v-else>Current Score: NOT REPORTED</h6>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="table-striped">
                                    <tr v-for="(bankruptcy,index) in userStore.userDashboard.publicRecordBankruptcyTable.values">
                                        <td style="text-align:left">
                                            <div class="badge badge-glow badge-danger badge-sm mr-0 mb-0"> 
                                                Public Record
                                            </div>
                                        </td>
                                        <td style="text-align:left">
                                            <div class="more-info" v-if="bankruptcy.transunion">
                                                <h6 class="mb-0" v-if="bankruptcy.transunion.type ">{{ bankruptcy.transunion.type }}</h6>
                                                <h6 class="mb-0" v-else>NOT REPORTED</h6>
                                                <small v-if="bankruptcy.transunion.reference_number">{{ bankruptcy.transunion.reference_number }}</small>
                                                <small v-else>--</small>
                                            </div>
                                            <div class="more-info" v-else>
                                                <h6 class="mb-0">NOT REPORTED</h6>
                                                <small>--</small>
                                            </div>
                                        </td>
                                        <td style="text-align:left">
                                            <div class="more-info" v-if="bankruptcy.equifax">
                                                <h6 class="mb-0" v-if="bankruptcy.equifax.type ">{{ bankruptcy.equifax.type }}</h6>
                                                <h6 class="mb-0" v-else>NOT REPORTED</h6>
                                                <small v-if="bankruptcy.equifax.reference_number">{{ bankruptcy.equifax.reference_number }}</small>
                                                <small v-else>--</small>
                                            </div>
                                            <div class="more-info" v-else>
                                                <h6 class="mb-0">NOT REPORTED</h6>
                                                <small>--</small>
                                            </div>
                                        </td>
                                        <td style="text-align:left">
                                            <div class="more-info" v-if="bankruptcy.experian">
                                                <h6 class="mb-0" v-if="bankruptcy.experian.type ">{{ bankruptcy.experian.type }}</h6>
                                                <h6 class="mb-0" v-else>NOT REPORTED</h6>
                                                <small v-if="bankruptcy.experian.reference_number">{{ bankruptcy.experian.reference_number }}</small>
                                                <small v-else>--</small>
                                            </div>
                                            <div class="more-info" v-else>
                                                <h6 class="mb-0">NOT REPORTED</h6>
                                                <small>--</small>
                                            </div>
                                        </td>
                                    </tr>

                                   <tr v-for="(derogatory,index) in userStore.userDashboard.collectionTable.values">
                                        <td style="text-align:left">
                                            <div class="badge badge-glow badge-danger badge-sm mr-0 mb-0">Derogatory Account</div>
                                        </td>
                                        <td style="text-align:left">
                                            <div class="more-info" v-if="derogatory.transunion">
                                                <h6 class="mb-0" v-if="derogatory.transunion.furnisher_name ">{{ derogatory.transunion.furnisher_name }}</h6>
                                                <h6 class="mb-0" v-else>NOT REPORTED</h6>
                                                <small v-if="derogatory.transunion.account_number">{{ derogatory.transunion.account_number }}</small>
                                                <small v-else>--</small>
                                                <small class="ml-1" v-if="derogatory.transunion.account_detail">{{ derogatory.transunion.account_detail }}</small>
                                                <small class="ml-1" v-else>--</small>
                                            </div>
                                            <div class="more-info" v-else>
                                                <h6 class="mb-0">NOT REPORTED</h6>
                                                <small>--</small>
                                                <small class="ml-1">--</small>
                                            </div>
                                        </td>
                                        <td style="text-align:left">
                                            <div class="more-info" v-if="derogatory.equifax">
                                                <h6 class="mb-0" v-if="derogatory.equifax.furnisher_name ">{{ derogatory.equifax.furnisher_name }}</h6>
                                                <h6 class="mb-0" v-else>NOT REPORTED</h6>
                                                <small v-if="derogatory.equifax.account_number">{{ derogatory.equifax.account_number }}</small>
                                                <small v-else>--</small>
                                                <small class="ml-1" v-if="derogatory.equifax.account_detail">{{ derogatory.equifax.account_detail }}</small>
                                                <small class="ml-1" v-else>--</small>
                                            </div>
                                            <div class="more-info" v-else>
                                                <h6 class="mb-0">NOT REPORTED</h6>
                                                <small>--</small>
                                                <small class="ml-1">--</small>
                                            </div>
                                        </td>
                                        <td style="text-align:left">
                                            <div class="more-info" v-if="derogatory.experian">
                                                <h6 class="mb-0" v-if="derogatory.experian.furnisher_name ">{{ derogatory.experian.furnisher_name }}</h6>
                                                <h6 class="mb-0" v-else>NOT REPORTED</h6>
                                                <small v-if="derogatory.experian.account_number">{{ derogatory.experian.account_number }}</small>
                                                <small v-else>--</small>
                                                <small class="ml-1" v-if="derogatory.experian.account_detail">{{ derogatory.experian.account_detail }}</small>
                                                <small class="ml-1" v-else>--</small>
                                            </div>
                                            <div class="more-info" v-else>
                                                <h6 class="mb-0">NOT REPORTED</h6>
                                                <small>--</small>
                                                <small class="ml-1">--</small>
                                            </div>
                                        </td>
                                    </tr>


                                    <tr v-for="(latepayment,index) in userStore.userDashboard.latepaymentTable.values">
                                        <td style="text-align:left">
                                            <div class="badge badge-glow badge-warning badge-sm mr-0 mb-0"> Late Payment </div>
                                        </td>
                                        <td style="text-align:left">
                                            <div class="more-info" v-if="latepayment.transunion">
                                                <h6 class="mb-0" v-if="latepayment.transunion.furnisher_name ">{{ latepayment.transunion.furnisher_name }}</h6>
                                                <h6 class="mb-0" v-else>NOT REPORTED</h6>
                                                <small v-if="latepayment.transunion.account_number ">{{ latepayment.transunion.account_number }}</small>
                                                <small v-else>-- </small>
                                                <small  class="ml-1" v-if="latepayment.transunion.account_detail">{{ latepayment.transunion.account_detail }}</small>
                                                <small class="ml-1" v-else>--</small>
                                            </div>
                                            <div class="more-info" v-else>
                                                <h6 class="mb-0">NOT REPORTED</h6>
                                                <small>--</small>
                                                <small class="ml-1">--</small>
                                            </div>
                                        </td>
                                        <td style="text-align:left">
                                            <div class="more-info" v-if="latepayment.equifax">
                                                <h6 class="mb-0" v-if="latepayment.equifax.furnisher_name ">{{ latepayment.equifax.furnisher_name }}</h6>
                                                <h6 class="mb-0" v-else>NOT REPORTED</h6>
                                                <small v-if="latepayment.equifax.account_number ">{{ latepayment.equifax.account_number }}</small>
                                                <small v-else>-- </small>
                                                <small  class="ml-1" v-if="latepayment.equifax.account_detail">{{ latepayment.equifax.account_detail }}</small>
                                                <small class="ml-1" v-else>--</small>
                                            </div>
                                            <div class="more-info" v-else>
                                                <h6 class="mb-0">NOT REPORTED</h6>
                                                <small>--</small>
                                                <small class="ml-1">--</small>
                                            </div>
                                        </td>
                                        <td style="text-align:left">
                                            <div class="more-info" v-if="latepayment.experian">
                                                <h6 class="mb-0" v-if="latepayment.experian.furnisher_name ">{{ latepayment.experian.furnisher_name }}</h6>
                                                <h6 class="mb-0" v-else>NOT REPORTED</h6>
                                                <small v-if="latepayment.experian.account_number ">{{ latepayment.experian.account_number }}</small>
                                                <small v-else>-- </small>
                                                <small  class="ml-1" v-if="latepayment.experian.account_detail">{{ latepayment.experian.account_detail }}</small>
                                                <small class="ml-1" v-else>--</small>
                                            </div>
                                            <div class="more-info" v-else>
                                                <h6 class="mb-0">NOT REPORTED</h6>
                                                <small>-- </small>
                                                <small class="ml-1">--</small>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr v-for="(inquiry,index) in userStore.userDashboard.inquiryTable.values">
                                        <td style="text-align:left">
                                            <div class="badge badge-glow badge-info badge-sm mr-0 mb-0"> Inquiry </div>
                                        </td>
                                        <td style="text-align:left">
                                            <div class="more-info" v-if="inquiry.transunion">
                                                <h6 class="mb-0" v-if="inquiry.transunion.creditor_name ">{{ inquiry.transunion.creditor_name }}</h6>
                                                <h6 class="mb-0" v-else>NOT REPORTED</h6>
                                                <small v-if="inquiry.transunion.date_of_inquiry">{{ inquiry.transunion.date_of_inquiry }}</small>
                                                <small v-else>--</small>
                                            </div>
                                            <div class="more-info" v-else>
                                                <h6 class="mb-0"> </h6>
                                                <small> -- </small>
                                            </div>
                                        </td>
                                        <td style="text-align:left">
                                            <div class="more-info" v-if="inquiry.equifax">
                                                <h6 class="mb-0" v-if="inquiry.equifax.creditor_name ">{{ inquiry.equifax.creditor_name }}</h6>
                                                <h6 class="mb-0" v-else>NOT REPORTED</h6>
                                                <small v-if="inquiry.equifax.date_of_inquiry">{{ inquiry.equifax.date_of_inquiry }}</small>
                                                <small v-else>--</small>
                                            </div>
                                            <div class="more-info" v-else>
                                                <h6 class="mb-0">--</h6>
                                                <small></small>
                                            </div>
                                        </td>
                                        <td style="text-align:left">
                                            <div class="more-info" v-if="inquiry.experian">
                                                <h6 class="mb-0" v-if="inquiry.experian.creditor_name ">{{ inquiry.experian.creditor_name }}</h6>
                                                <h6 class="mb-0" v-else>NOT REPORTED</h6>
                                                <small v-if="inquiry.experian.date_of_inquiry">{{ inquiry.experian.date_of_inquiry }}</small>
                                                <small v-else>--</small>
                                            </div>
                                            <div class="more-info" v-else>
                                                <h6 class="mb-0"> </h6>
                                                <small>--</small>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="mx-auto">
            <h3 class="text-center">You don't have a credit report</h3>
        </div>
        <div style="text-align:center;">
            <a href="https://www.smartcredit.com/?PID=54821" target="_blank" type="submit"
                class="btn btn-outline-primary ">
                <i data-feather="external-link" class="mr-25"></i> <span>SmartCredit</span>
            </a>
        </div>
    </div>
</template>
<script>
import { useLocalizationStore } from '../../../../stores/LocalizationStore.js'
import { useUserStore } from '../../../../stores/UserStore.js'
export default{
    setup(){
        return {
            localizationStore:useLocalizationStore(),
            userStore:useUserStore(),
        }
    },
}
</script>
